<script setup lang="ts">
</script>

<template>
  <UHeader :ui="{ left: 'h-full' }" :toggle="false">
    <template #left>
      <div class="flex items-center justify-start h-full">
        <NuxtLink to="/" class="h-full">
          <Logo class="h-full" />
        </NuxtLink>
      </div>
    </template>
    <template #right>
      <UColorModeButton />
    </template>
  </UHeader>
</template>
